import { render, staticRenderFns } from "./MagazzinoArticoliCodiciLottoMatricoleListComponent.vue?vue&type=template&id=c4191cb0&scoped=true"
import script from "./MagazzinoArticoliCodiciLottoMatricoleListComponent.vue?vue&type=script&lang=js"
export * from "./MagazzinoArticoliCodiciLottoMatricoleListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4191cb0",
  null
  
)

export default component.exports